import { render, staticRenderFns } from "./TheBuyHardwareWalletLayout.vue?vue&type=template&id=1b9746ae&scoped=true"
import script from "./TheBuyHardwareWalletLayout.vue?vue&type=script&lang=js"
export * from "./TheBuyHardwareWalletLayout.vue?vue&type=script&lang=js"
import style0 from "./TheBuyHardwareWalletLayout.vue?vue&type=style&index=0&id=1b9746ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9746ae",
  null
  
)

export default component.exports